import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import PageLoader from './components/PageLoader';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Manuscripts from './components/Manuscripts';
import Philosophy from './components/Philosophy';
import Features from './components/Features';
import Footer from './components/Footer';
import GitaChat from './components/GitaChat';
import MusicPlayer from './components/MusicPlayer';

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // Intersection Observer for fade-in animations
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe elements
    document.querySelectorAll('.manuscript-card, .feature, .philosophy-content').forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={
            <>
              {/* Background Mantra Circles */}
              <div className="mantra-circle-1">
                <svg viewBox="0 0 100 100">
                  <defs>
                    <path id="circle1" d="M 50,50 m -15,0 a 15,15 0 1,1 30,0 a 15,15 0 1,1 -30,0" />
                  </defs>
                  <text>
                    <textPath href="#circle1" startOffset="0%">
                      ॐ भूर्भुवः स्वः। तत्सवितुर्वरेण्यं। भर्गो देवस्य धीमहि। धियो यो नः प्रचोदयात्॥
                    </textPath>
                  </text>
                </svg>
              </div>
              <div className="mantra-circle-2">
                <svg viewBox="0 0 100 100">
                  <defs>
                    <path id="circle2" d="M 50,50 m -22,0 a 22,22 0 1,1 44,0 a 22,22 0 1,1 -44,0" />
                  </defs>
                  <text>
                    <textPath href="#circle2" startOffset="0%">
                      ॐ भूर्भुवः स्वः। तत्सवितुर्वरेण्यं। भर्गो देवस्य धीमहि। धियो यो नः प्रचोदयात्॥
                    </textPath>
                  </text>
                </svg>
              </div>
              <div className="mantra-circle-3">
                <svg viewBox="0 0 100 100">
                  <defs>
                    <path id="circle3" d="M 50,50 m -30,0 a 30,30 0 1,1 60,0 a 30,30 0 1,1 -60,0" />
                  </defs>
                  <text>
                    <textPath href="#circle3" startOffset="0%">
                      ॐ भूर्भुवः स्वः। तत्सवितुर्वरेण्यं। भर्गो देवस्य धीमहि। धियो यो नः प्रचोदयात्॥
                    </textPath>
                  </text>
                </svg>
              </div>

              <Navigation />
              <Hero />
              <Manuscripts />
              <Philosophy />
              <Features />
              <Footer />
              <MusicPlayer />
            </>
          } />
          <Route path="/gita" element={
            <>
              <GitaChat />
              <MusicPlayer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
